import { useCallback } from "react";
import { hapticButton, hapticSuccess, hapticError, hapticSelection } from "@/utils/haptics";

export type HapticType = 'button' | 'success' | 'error' | 'selection';

/**
 * Hook for adding haptic feedback to button interactions
 * Provides consistent tactile feedback across the application
 */
export const useHapticButton = (type: HapticType = 'button') => {
  const triggerHaptic = useCallback(() => {
    switch (type) {
      case 'success':
        hapticSuccess();
        break;
      case 'error':
        hapticError();
        break;
      case 'selection':
        hapticSelection();
        break;
      case 'button':
      default:
        hapticButton();
        break;
    }
  }, [type]);

  return triggerHaptic;
};
